import {GitHubAvatar} from '@github-ui/github-avatar'
import {ChevronRightIcon} from '@primer/octicons-react'
import {ActionList, type ActionListItemProps} from '@primer/react'
import {clsx} from 'clsx'

import type {AutocompleteRepository} from '../../utils/copilot-chat-types'
import sharedStyles from './shared.module.css'

interface RepositorySuggestionProps extends ActionListItemProps {
  repository: AutocompleteRepository
  isMultistep?: boolean
  stale?: boolean
}

export function RepositorySuggestion({repository, isMultistep, stale, className, ...props}: RepositorySuggestionProps) {
  return (
    <ActionList.Item
      key={repository.nameWithOwner}
      {...props}
      className={clsx(sharedStyles.asyncSuggestion, stale && sharedStyles.stale, className)}
    >
      <ActionList.LeadingVisual>
        <GitHubAvatar src={repository.ownerAvatar} alt="" size={16} square={repository.ownerType === 'Organization'} />
      </ActionList.LeadingVisual>
      {repository.nameWithOwner}
      {isMultistep && (
        <ActionList.TrailingVisual>
          <ChevronRightIcon />
        </ActionList.TrailingVisual>
      )}
    </ActionList.Item>
  )
}

try{ RepositorySuggestion.displayName ||= 'RepositorySuggestion' } catch {}